export const locale = {
    lang: 'en',
    data: {
        TRANSFORM_EXPORT: 'Export card to another activity',
        SELECTION: 'Selection',
        ACTIVITY: 'Activity',
    }
};
